import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { ScrollTop } from './components/scroll-top'
import { Content } from './components/content'
import { Sidebar } from './components/sidebar'
import { PageDataProvider } from './core'
import { reInitMenu } from '../helpers'
import '../layout/style/style.css'
import { Footer } from './components/footer/Footer'

const MasterLayout = () => {
  const location = useLocation()
  useEffect(() => {
    reInitMenu()
  }, [location.key])

  return (
      <PageDataProvider>
        <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
          <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
            <div id="masterHeader">
            </div>
            <div className='app-wrapper flex-column'>
              <div id='subHeader'>
              </div>
              <div id='pageHeader' style={{ borderBottom: '1px solid #DDE1E6' }}>
              </div>
            </div>
            <div className='app-wrapper flex-column flex-row-fluid masterLayoutMargin' id='kt_app_wrapper'>
              <Sidebar />
              <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                <div className='d-flex flex-column flex-column-fluid'>
                  <Content>
                    <Outlet />
                  </Content>
                </div>
              </div>
            <Footer />
            </div>
          </div>
        </div>
        <ScrollTop />
      </PageDataProvider>
  )
}

export { MasterLayout }
